import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type SocialEngagePost from "./SocialEngagePost";
import { type SocialMetadata } from "./SocialMetadata";
import type User from "./User";

@Model()
class SocialEngagePostEvent extends ApplicationRecord {
  static jsonapiType = "social_engage_post_events";

  @Attr({ persist: false }) createdAt: string;

  @Attr() eventType: string;

  @Attr() metadata: SocialMetadata;

  @BelongsTo() socialEngagePost: SocialEngagePost;

  @Attr() socialEngagePostId: number;

  @BelongsTo() user: User;

  @Attr() userId: number;

  @Attr() username: string;
}

export default SocialEngagePostEvent;
